function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27 16.925L25.5 18.325L27.2 19.925H19V21.925H27.2L25.5 23.525L27 24.925L31 20.925L27 16.925Z",
  fill: "#CED2E3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1 25.825C13.7 24.525 13 22.825 13 20.925C13 19.025 13.7 17.325 15.1 16.025C17.8 13.325 22.3 13.325 25 16.025L26.4 14.625C22.9 11.125 17.2 11.125 13.7 14.625C11.9 16.225 11 18.525 11 20.925C11 23.325 11.9 25.625 13.6 27.325C15.4 29.025 17.7 29.925 20 29.925C22.3 29.925 24.6 29.025 26.4 27.325L25 25.825C22.2 28.625 17.8 28.625 15.1 25.825Z",
  fill: "#CED2E3"
});

var SvgSignOutIcon = function SvgSignOutIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSignOutIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sign-out-icon.6eaedd99.svg";
export { ForwardRef as ReactComponent };